
import { ETextAlign, PosterRender, PImage, PText, PRect } from '@bilibili/poster-render'
import qrcode from 'qrcode'
import uploadImg from '@plat-components/utils2/_esm5/uploadImg'
import { makeShareUrl, oneToWan } from '@common/utils'
import { timestamp2date } from './filter'
// import posterBg from '../../assets/h5/1次.png'
import posterBg1 from '../../assets/h5/fangyu-card-poster.png'
import posterBg2 from '../../assets/h5/fantan-card-poster.png'
import posterBg3 from '../../assets/h5/tanbai-card-poster.png'
import posterBg4 from '../../assets/h5/yule-card-poster.png'

const httptoHttpsUrl = (url: string) => {
  return url.replace('http://', 'https://')
}


export async function drawPoster(posterData: any): Promise<Blob> {
  const p = new PosterRender({
    width: 514,
    height: 914
  })

  // 先加载所有图片
  const posterList = await PosterRender.loadImage([
    posterBg1,
    posterBg2,
    posterBg3,
    posterBg4
  ])

  const getPosterImg = (num: number) =>{
    return posterList[num - 1]
  }

  // 背景图
  p.add(new PImage({
    src: getPosterImg(posterData) as HTMLImageElement,
    x: 0,
    y: 0,
    w: 514,
    h: 914,
  }))
    

  p.render()
  return p.toBase64() as any
}

export function uploadImage(shareImg: Blob) {
  return uploadImg(shareImg)
    .then((res: any) => {
      const { code, data } = res
      if (code === 0) {
        const { location: url } = data
        if (url) {
          return url
        }
      }
    })
}
